export const theme = {

    duration: {
      fast: '0.3s',
      normal: '0.6s',
      sluggish: '0.9s',
      slow: '3.2s',
      abstract: '60s',
      pageTransition: '0.6s',
      pageTransitionDelay: '0.3s',
      raw: {
        fast: 0.3,
        normal: 0.6,
        sluggish: 0.9,
        slow: 3.2,
        abstract: 60,
        pageTransition: 0.6,
        pageTransitionDelay: 0.3
      }
    },
  }
  